import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import DraftIcon from '@plato/ui-legacy/assets/icons/draft-icon';
import { DialogStateManager } from '@plato/ui-legacy/components/dialog/dialog-provider';
import { Button } from '@plato/ui-legacy/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@plato/ui/containers/dropdown-menu';
import { MenuItemLabel, MenuItemLeading } from '@plato/ui/primitives/menu';
import { PlusIcon } from 'lucide-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownMenuItemCreateEvent } from '../../events/components/dropdown-menu-item-create-event.tsx';
import { DropdownMenuItemCreateNote } from '../../notes/components/dropdown-menu-item-create-note.tsx';
import { DraftOrderCreateDialog } from '../../sales-draft-new/views/create-draft-order-dialog.tsx';
import { DropdownMenuItemCreateTask } from '../../tasks/components/dropdown-menu-item-create-task.tsx';

export type CreateNewOrderMenuProps = {
    showFullInput?: boolean;
    className?: string;
    onClose?: () => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

function CreateNewMenu({ showFullInput = true }: CreateNewOrderMenuProps): React.ReactNode {
    const { t } = useTranslation();
    const { transactionDraftAvailability } = useAppConfig();
    const [open, setOpen] = React.useState(false);

    const { showSidebarCreateNewButton } = useAppConfig();
    if (!showSidebarCreateNewButton) {
        return null;
    }

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger
                render={
                    showFullInput ? (
                        <Button
                            className="w-full justify-start"
                            variant="ghost"
                            selected={open}
                            onClick={() => {
                                setOpen(true);
                            }}
                            leftIcon={PlusIcon}
                        >
                            <span>{t('top_navbar__new_actvity')}</span>
                        </Button>
                    ) : (
                        <Button
                            size="icon-s"
                            variant="outline"
                            selected={open}
                            onClick={() => {
                                setOpen(true);
                            }}
                        >
                            <PlusIcon className="flex h-4 w-4 shrink-0 " />
                        </Button>
                    )
                }
            />
            <DropdownMenuContent align="start" side="right" className="z-9999">
                <DropdownMenuItemCreateTask links={[]} source="navigation_menu" />
                {transactionDraftAvailability !== 'UNAVAILABLE' && (
                    <DropdownMenuItem
                        onClick={() => {
                            void DialogStateManager.show(DraftOrderCreateDialog, {
                                source: 'navigation_menu',
                            });
                        }}
                    >
                        <MenuItemLeading>
                            <DraftIcon />
                        </MenuItemLeading>
                        <MenuItemLabel>{t('top_navbar__new_draft')}</MenuItemLabel>
                    </DropdownMenuItem>
                )}
                <DropdownMenuItemCreateEvent analyticsSource="menu" />
                <DropdownMenuItemCreateNote analyticsSource="side_menu" />
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

export { CreateNewMenu };
